import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Form, Icon, Input, Button, Select, notification } from 'antd';
import { loginUser } from '../../Redux/actions/authActions'
import logo from '../../assets/pantrylogo.png'
import Footer from '../../Components/Footer'
import axios from 'axios'
import countries from '../../countries'
import { serverUrl } from '../../Config/api'


const { Option } = Select

const title = "Error"


class Register extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            disable: false,
            updatedCuntries: []
        }
    }

    openNotification = (title, desc, icon, color = '#108ee9') => {
        notification.open({
            message: title,
            description: desc,
            icon: <Icon type={icon} style={{ color: color }} />,
        });
    };

    componentDidMount() {
        const { user, history, loginUser } = this.props
        console.log('user', user)

        if (!user) {
            history.replace('/login')
        }
        else if (user.role === 'admin') {
            history.replace('/')
        }
        else {
            axios.get(`${serverUrl}/admin/get/get-admin/${user._id}`)
                .then((result) => {
                    const { data } = result
                    if (data.success) {
                        const { admin } = data
                        loginUser(admin)
                        admin.country.map((v, i) => {
                            var index = countries.indexOf(v)
                            countries.splice(index, 1)
                        })
                        this.setState({ updatedCuntries: countries })
                    }
                    else {
                        history.replace('/login')
                    }
                })
                .catch(() => {
                    history.replace('/login')
                })
        }
    }

    handleSubmit = e => {
        const { user, form, loginUser } = this.props
        const { validateFields } = form
        e.preventDefault();
        validateFields((err, values) => {
            if (!err) {
                values.adminId = user._id
                this.setState({ disable: true, loading: true })
                axios.post(`${serverUrl}/admin/user/signup`, values)
                    .then((result) => {
                        const { data } = result
                        if (data.success) {
                            this.openNotification('Success', data.message, 'check')
                            loginUser(data.data)
                            setTimeout(() => {
                                this.setState({ disable: false, loading: false })
                                window.location.reload()
                            }, 500)
                        }
                        else {
                            this.openNotification(title, data.message, 'close-circle', 'red')
                            this.setState({ disable: false, loading: false })
                        }
                    })
                    .catch((err) => {
                        this.openNotification(title, "OOPS Something went wrong!!!", 'close-circle', 'red')
                        this.setState({ disable: false, loading: false })
                    })
            }
        });
    };

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('password')) {
            callback('Two passwords that you enter is inconsistent!');
        } else {
            callback();
        }
    };

    render() {
        const { loading, disable, updatedCuntries } = this.state
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <div className="advertisement">
                </div>
                <header className="header1 bg-light">
                    <nav className="navbar  navbar-light">
                        <div className="container">
                            <a className="navbar-brand" href="#"><img src={logo} alt="logo" className="img-fluid" /></a>
                            <div className="collapse navbar-collapse" id="collapsingNavbar">
                            </div>
                            <p className="nav-item"><Link className="nav-link" to="/invoice">Logout</Link> </p>
                        </div>
                    </nav>
                </header>
                <div className="main-content-bg">
                    <div id="contact" />
                    <section className="contact">
                        <div className="center1">
                            <div className="card2">
                                <Form
                                    className="login-form form-w"
                                    hideRequiredMark={true}
                                    onSubmit={this.handleSubmit}
                                    encType="multipart/form-data">
                                    <h1 className="heading1" >Register</h1>
                                    <Form.Item
                                        label="Admin Name"
                                    >
                                        {getFieldDecorator('userName', {
                                            rules: [{ required: true, message: 'Please input Username!' }],
                                        })(
                                            <Input
                                                type="text"
                                                placeholder="Username"
                                            />,
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label="Email"
                                    >
                                        {getFieldDecorator('email', {
                                            rules: [{ required: true, message: 'Please input Email!' }],
                                        })(
                                            <Input
                                                type="email"
                                                placeholder="Email"
                                            />,
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label="Password"
                                    >
                                        {getFieldDecorator('password', {
                                            rules: [{ required: true, message: 'Please input Password!' }],
                                        })(
                                            <Input.Password
                                                minLength={9}
                                                placeholder="Password (minimum of 9 characters)"
                                            />,
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label="Confirm Password"
                                    >
                                        {getFieldDecorator('confirmPass', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Please input Password!'
                                                },
                                                {
                                                    validator: this.compareToFirstPassword,
                                                }
                                            ],
                                        })(
                                            <Input.Password
                                                minLength={9}
                                                placeholder="Confirm Password"
                                            />,
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label="Country"
                                    >
                                        {getFieldDecorator('country', {
                                            rules: [{ required: true, message: 'Please Select Country!' }],
                                        })(
                                            <Select
                                                showSearch
                                                showArrow
                                                mode="multiple"
                                                style={{ backgroundColor: '#fff' }}
                                                placeholder="Select Country"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {
                                                    updatedCuntries.map((v, i) => {
                                                        return <Option value={v} key={i}>{v}</Option>
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                    <Form.Item>
                                        <div className="submit-btn">
                                            <Button htmlType="submit" loading={loading} disabled={disable} className="btn" style={{ backgroundColor: '#0587EF', color: 'white', fontWeight: 'bold', fontSize: 14, height: 50, display: 'flex', width: '100%', textAlign: 'center', justifyContent: 'center', alignItems: 'center', boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}>
                                                Add Admin
                                        </Button>
                                        </div>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer {...this.props} />
            </div>
        )
    }
}

const RegisterForm = Form.create({ name: 'normal_login' })(Register);

const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loginUser: (user) => dispatch(loginUser(user)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm)